import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { ContractorsPlannedHoursWizardService } from "@/services/contractorsPlannedHoursWizardService";
import { SuccessFetchListResponse } from "@/services/api";
import { DisplayContractorsPlannedHoursWizardAllocation } from "@/types/contractorsPlannedHoursWizard";
import { useCallback } from "react";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

export const CONTRACTORS_PLANNED_HOURS_WIZARD_ALLOCATIONS_TABLE =
  "contractorsPlannedHoursWizardAllocations" as const;

export const useContractorsPlannedHoursWizardQuery = () => {
  const options =
    useCreateDataTableOptions<DisplayContractorsPlannedHoursWizardAllocation>(
      CONTRACTORS_PLANNED_HOURS_WIZARD_ALLOCATIONS_TABLE,
    );
  const queryKey = useDynamicQueryParams(
    CONTRACTORS_PLANNED_HOURS_WIZARD_ALLOCATIONS_TABLE,
    options,
  );

  const queryFn = useCallback(
    ({ pageParam }: { pageParam: string | undefined }) =>
      ContractorsPlannedHoursWizardService.getList({
        lastItem: pageParam,
        filters: options.filters,
        sorting: options.sorting[0],
      }),
    [options.filters, options.sorting],
  );

  const getNextPageParam = useCallback(
    (
      lastPage: SuccessFetchListResponse<DisplayContractorsPlannedHoursWizardAllocation>,
    ) => lastPage.last_item,
    [],
  );

  const query = useInfiniteQuery({
    queryKey,
    queryFn,
    initialPageParam: undefined,
    getNextPageParam,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  return { query, options };
};
